import { createContext, useCallback, useContext, useRef } from 'react';
import { loadMulpay, MultiPayment } from '@mul-pay/mptoken-js';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

/**
 * Mulpayを使用する
 *
 * mptoken-react-js では multiPayment オプションにPromiseを渡すのでPromiseをそのまま帰す
 */
export const useMulpay = (): UseMulpayValue => useContext(Context)();

export type UseMulpayValue = Promise<MultiPayment | null>;

const Context = createContext<() => UseMulpayValue>(async () => null);

export const MulpayProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const ref = useRef<UseMulpayValue | null>(null);

  // 最初に useMulpay されたタイミングで loadMulpay が実行され、結果は共有される
  const load = useCallback(() => {
    ref.current ||= loadMulpay(
      process.env.NEXT_PUBLIC_MULPAY_API_KEY || '',
      process.env.NEXT_PUBLIC_MULPAY_PUBLIC_KEY || '',
      undefined,
      true,
      publicRuntimeConfig.coubicEnv === 'production',
    );
    return ref.current;
  }, []);

  return <Context.Provider value={load}>{children}</Context.Provider>;
};
